import { appInfo } from './mockData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-shrink-0 w-48 md:w-56">
              <img
                src={appInfo.image}
                alt="555电影网移动客户端"
                className="w-full h-auto rounded-3xl"
              />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 mb-4">
                <i className="ri-smartphone-line text-primary-600 text-sm"></i>
                <span className="text-primary-700 text-xs font-medium">移动观影</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
                {appInfo.title}
              </h2>
              <p className="text-lg text-foreground-500 mb-4">{appInfo.subtitle}</p>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                {appInfo.desc}
              </p>

              <div className="grid grid-cols-2 gap-3 mb-8">
                {appInfo.features.map((feat, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-check-line text-primary-600 text-xs"></i>
                    </div>
                    <span className="text-sm text-foreground-700">{feat}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <button className="w-full sm:w-auto px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                  <i className="ri-apple-line mr-2"></i>
                  App Store
                </button>
                <button className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                  <i className="ri-android-line mr-2"></i>
                  Android 下载
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}